import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCQtEiiaVDUT_2qLv1pTwI_5bKTfNUcr7k",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "ldr-webapp.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://ldr-webapp-default-rtdb.firebaseio.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "ldr-webapp",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "ldr-webapp.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1082760549496",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1082760549496:web:af501235d151cb31ee098d",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);

export default app;
